import { render } from "./ElixirArea.vue?vue&type=template&id=76baa239&scoped=true"
import script from "./ElixirArea.vue?vue&type=script&lang=js"
export * from "./ElixirArea.vue?vue&type=script&lang=js"

import "./ElixirArea.vue?vue&type=style&index=0&id=76baa239&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76baa239"]])

export default __exports__